import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useGetDimensionGroup } from "../../hooks/useGetDimensionGroup";
import { getFallbacksForImages } from "./utils";
var FALLBACK_PICTURE_LINK = 'https://static.beeline.ru/upload/images/error-content-cat.png';
var parenthesesRegExp = /(\(|\))/gi;
var Picture = /*#__PURE__*/memo(function (_ref) {
  var src = _ref.src,
    title = _ref.title,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? true : _ref$lazy,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? [] : _ref$source,
    onError = _ref.onError,
    _ref$fallbackSrc = _ref.fallbackSrc,
    fallbackSrc = _ref$fallbackSrc === void 0 ? FALLBACK_PICTURE_LINK : _ref$fallbackSrc,
    className = _ref.className,
    backgroundPosition = _ref.backgroundPosition;
  var _useState = useState(src),
    _useState2 = _slicedToArray(_useState, 2),
    pictureSrc = _useState2[0],
    setPictureSrc = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    _source = _useState4[0],
    setSource = _useState4[1];
  var _useState5 = useState('center'),
    _useState6 = _slicedToArray(_useState5, 2),
    objectPosition = _useState6[0],
    setObjectPosition = _useState6[1];
  var deviceType = useGetDimensionGroup();
  useEffect(function () {
    if (deviceType && backgroundPosition) {
      setObjectPosition(backgroundPosition[deviceType] || backgroundPosition.desktop || 'center');
    }
  }, [deviceType, backgroundPosition]);

  // Picture тэг не умеет нормально обрабатывать ошибки, когда
  // srcset не доступен, поэтому нужно делать фолбэк руками
  useEffect(function () {
    var images = source.map(function (s) {
      return s.srcset;
    });
    getFallbacksForImages(images, fallbackSrc).then(function (imagesWithFallback) {
      var updatedImages = source.map(function (image, i) {
        return _objectSpread(_objectSpread({}, image), {}, {
          srcset: imagesWithFallback[i]
        });
      });
      setSource(updatedImages);
    }).catch(console.error);
  }, []);
  var onErrorHandler = useCallback(function (event) {
    if (onError) {
      onError(event);
    }
    setPictureSrc(fallbackSrc);
  }, [setPictureSrc, fallbackSrc, onError]);
  useEffect(function () {
    setPictureSrc(src);
  }, [src]);
  if (_source.length > 0) {
    return /*#__PURE__*/React.createElement("picture", {
      "data-t-id": "components-Picture"
    }, _source.map(function (item, index) {
      return item && /*#__PURE__*/React.createElement("source", {
        key: "source-".concat(+index),
        media: parenthesesRegExp.test(item.media) ? item.media : "(".concat(item.media, ")"),
        srcSet: item.srcset
      });
    }), /*#__PURE__*/React.createElement("img", {
      alt: alt,
      className: className,
      loading: lazy ? 'lazy' : undefined,
      onError: onErrorHandler,
      src: pictureSrc,
      style: {
        objectPosition: objectPosition
      },
      title: title
    }));
  }
  return /*#__PURE__*/React.createElement("img", {
    alt: alt,
    className: className,
    loading: lazy ? 'lazy' : undefined,
    onError: onErrorHandler,
    src: pictureSrc,
    style: {
      objectPosition: objectPosition
    },
    title: title
  });
});
export { Picture };